import {StringBuilder} from "../../AppUtils.js";
import moment from "moment";
import React from "react";
import {openWindow} from "../../http/WindowOpener.jsx";
import {
    BriefShortcutFilterValues,
    BriefShortcutToText
} from "../../company/CompanyAccountProfile/CompanyBriefs/consts.jsx";
import {isEqual} from "lodash";

export const createLinkElement = (href, text) => (
    <a
        href={href}
        onClick={e => {
            e.preventDefault();
            openWindow(href);
        }}
        style={{cursor: "pointer", textDecoration: "underline"}}>
        {text}
    </a>
);

export const providerBriefProjection = [
    "brifId",
    "maxPrice",
    "dtstart",
    "createdAt",
    "status",
    "description",
    "providerIds",
    "address",
    "floor",
    "participantsAmount",
    "poNumber",
    "bidsIds",
    "bids",
    "systemId",
    "watchedByAdmin",
    "assignedCSMs",
    "updatedAt",
    "adminComment",
    "removedProviderIds",
    "briefNumber"
];

export const briefPageSize = 10;

export const BriefStatus = {
    pending: "pending",
    haveBids: "haveBids",
    cancelled: "cancelled",
    accepted: "accepted"
};

export const BidStatus = {
    pending: "pending",
    cancelled: "cancelled",
    accepted: "accepted",
    watched: "watched",
    haveNote: "haveNote"
};

const isBriefCancel = (brief, me) => {
    const isCancelled = brief?.bids?.some(bid => bid.providerId === me?.userId && bid.status === BidStatus.cancelled);

    const bid = brief?.bids?.find(bid => bid.status === BidStatus.accepted);
    const isMyAcceptedBid = !!bid?.order && bid?.providerId === me?.userId;

    return isCancelled || !isMyAcceptedBid;
};

export const BriefStatusToColorProvider = {
    [BriefStatus.pending]: [
        "ממתין לבניית הצעת מחיר",
        "",
        "var(--warning-transparent-background)",
        "var(--warning-lightes-background)"
    ],
    [BriefStatus.cancelled]: ["בוטלה", "", "var(--grey-lightes-color)", "var(--grey-transparent-background)"],
    [BriefStatus.accepted]: [
        (brief, me) => {
            const isCancelled = isBriefCancel(brief, me);
            return isCancelled ? "הצעת מחיר סורבה" : "הצעת מחיר מאושרת";
        },
        (brief, me) => {
            if (brief?.removedProviderIds?.includes(me?.userId)) {
                return "";
            }
            if (brief?.bids?.some(bid => bid.providerId === me?.userId && bid.status === BidStatus.cancelled)) {
                return "";
            }
            const bid = brief?.bids?.find(bid => bid.status === BidStatus.accepted);
            if (!bid?.order) {
                return "";
            }

            if (bid?.providerId !== me?.userId) {
                return "";
            }

            const url = `/events/${bid?.order?.eventId}/proposalV2`;
            return (
                <span>
                    {bid?.order?.providerBrand} | הזמנה מס {createLinkElement(url, bid?.order?.proposalId)}
                </span>
            );
        },
        (brief, me) => (isBriefCancel(brief, me) ? "var(--grey-lightes-color)" : "var(--lightes-accept-color)"),
        (brief, me) => (isBriefCancel(brief, me) ? "var(--grey-transparent-background)" : "var(--light-accept-color)")
    ],
    [BriefStatus.haveBids]: [
        (brief, me) =>
            !brief?.bids?.filter(bid => bid.providerId === me?.userId)?.length
                ? "ממתין לבניית הצעת מחיר"
                : brief?.bids?.some(bid => bid.providerId === me?.userId && bid.note)
                ? "ממתין לתיקונים בהצעת מחיר"
                : "הצעת מחיר נשלחה ללקוח",
        (brief, me) =>
            !brief?.bids?.filter(bid => bid.providerId === me?.userId)?.length
                ? ""
                : brief?.bids?.some(bid => bid.providerId === me?.userId && bid.note)
                ? ""
                : `${moment(brief?.updatedAt).format("DD-MM-YYYY HH:mm")}`,
        (brief, me) =>
            !brief?.bids?.some(bid => bid.providerId === me?.userId) ||
            brief.bids.some(bid => bid.providerId === me?.userId && bid.note)
                ? "var(--warning-transparent-background)"
                : "var(--standard-primary-color)",
        (brief, me) =>
            brief?.bids?.some(bid => bid.providerId === me?.userId && !bid.note)
                ? "var(--lightes-secondary-color)"
                : "var(--warning-lightes-background)"
    ]
};

export const providerSelectedActions = {
    viewBrief: "viewBrief",
    canceledBrief: "canceledBrief",
    cancelBid: "cancelBid",
    editBrief: "editBrief"
};

export const ProviderBriefsShortcuts = [
    {
        key: BriefShortcutFilterValues.PENDING_FOR_BIDS,
        label: BriefShortcutToText[BriefShortcutFilterValues.PENDING_FOR_BIDS],
        value: BriefShortcutFilterValues.PENDING_FOR_BIDS,
        statuses: [BriefStatus.pending, BriefStatus.haveBids],
        searchByCreated: false,
        datePicked: () => [moment(), moment().add(3, "months")],
        isChecked: ({statuses}) => isEqual(statuses, [BriefStatus.pending, BriefStatus.haveBids])
    }
];
